module.exports = __webpack_public_path__ + "assets/1828359868641183e88b7c312b4ca780.svg";